import Tooltip from "./Tooltip";
import { CONNECTION_TYPE } from "../../utils/constants";
import { getConnectionTypeLabel } from "../../utils/common_utils";

const WifiIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    className="size-full"
    aria-hidden="true"
    data-testid="connection-icon-wifi"
  >
    <path
      d="M2 8.82C7.71 4.39 16.29 4.39 22 8.82"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5 12.86C9.03 9.72 14.97 9.72 19 12.86"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.5 16.86C10.63 15.25 13.37 15.25 15.5 16.86"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx="12" cy="20" r="1.25" fill="currentColor" />
  </svg>
);

const LteIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    className="size-full"
    aria-hidden="true"
    data-testid="connection-icon-lte"
  >
    <path d="M4 20V16.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    <path d="M9.33 20V12.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    <path d="M14.67 20V8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    <path d="M20 20V4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

const SignalIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    className="size-full"
    aria-hidden="true"
    data-testid="connection-icon-signal"
  >
    <path
      d="M19.1414 5.00003C20.9097 6.80378 22 9.27458 22 12C22 14.7578 20.8836 17.2549 19.0782 19.064M5 19.1415C3.14864 17.3265 2 14.7974 2 12C2 9.235 3.12222 6.73208 4.93603 4.92188"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.2849 8.04397C17.3458 9.05877 18 10.4488 18 11.9822C18 13.5338 17.3302 14.9386 16.2469 15.9564M7.8 16C6.68918 14.9789 6 13.556 6 11.9822C6 10.4266 6.67333 9.01843 7.76162 8"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx="12" cy="12" r="2" stroke="currentColor" strokeWidth="1.5" />
  </svg>
);

const ICONS_BY_CONNECTION_TYPE = {
  [CONNECTION_TYPE.WIFI]: WifiIcon,
  [CONNECTION_TYPE.LTE]: LteIcon,
};

const buildTooltipLabel = (connected, connectionType) => {
  if (!connected) {
    return "Not Connected";
  }

  const connectionTypeLabel = getConnectionTypeLabel(connectionType);
  return connectionTypeLabel ? `Connected over ${connectionTypeLabel}` : "Connected";
};

const RESOLVED_SINCE_LAST_CONNECTION_NOTE =
  "Note: this alarm may have been resolved since last connection";

const ConnectionStatusIcon = ({
  connected,
  connectionType,
  className = "size-6",
  "data-testid": dataTestId = "connection-status-icon",
  hasActiveAlert = false,
}) => {
  const Icon =
    connected && Object.prototype.hasOwnProperty.call(ICONS_BY_CONNECTION_TYPE, connectionType)
      ? ICONS_BY_CONNECTION_TYPE[connectionType]
      : SignalIcon;
  const tooltipLabel = buildTooltipLabel(connected, connectionType);
  const shouldShowResolvedSinceLastConnectionNote = !connected && hasActiveAlert;

  return (
    <Tooltip
      content={
        <>
          {tooltipLabel}
          {shouldShowResolvedSinceLastConnectionNote && (
            <>
              <br />
              {RESOLVED_SINCE_LAST_CONNECTION_NOTE}
            </>
          )}
        </>
      }
      className={`connectedHolder ${connected ? "text-resolved" : "text-disconnected"} ${className}`}
      bubbleClassName={
        shouldShowResolvedSinceLastConnectionNote
          ? "whitespace-normal w-48 text-center"
          : "whitespace-nowrap"
      }
      role="img"
      aria-label={
        shouldShowResolvedSinceLastConnectionNote
          ? `${tooltipLabel}. ${RESOLVED_SINCE_LAST_CONNECTION_NOTE}`
          : tooltipLabel
      }
      data-testid={dataTestId}
    >
      <Icon />
    </Tooltip>
  );
};

export default ConnectionStatusIcon;
